var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"baseButton",class:[
    _vm.type ? ("baseButton--" + _vm.type) : false,
    {'baseButton--disabled': _vm.disabled } ],attrs:{"href":_vm.href || false},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7cf303","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Ulmar/partials/BaseButton.vue
// module id = null
// module chunks = 